<template>
  <div>
    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <v-row>
            <v-card-text class="pa-0 fo-101">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="reviews"
                hide-default-footer
                item-key="name"
                class="row-pointer"
                @click:row="salesDetails($event)"
              >
                {{ event }}
                <template v-slot:no-data>
                  <noData
                    class="mt-10 container justify-center item-center"
                    name="SMS Service"
                  />
                </template>
                <!-- Status -->
                <template v-slot:item.created_at="{ item }">
                  {{ item.created_at | formatDate }}
                </template>
                <template v-slot:item.rating_value="{ item }">
                  <v-rating
                    v-model="item.rating_value"
                    background-color="orange lighten-3"
                    color="orange"
                    large
                  ></v-rating>
                </template>
                <template v-slot:item.sale="{ item }">
                  {{ item.sale ? item.sale.reference_number : '---' }}
                </template>
                <template v-slot:item.sale.customer.name="{ item }">
                  {{ item.sale ? item.sale.customer.name : '---' }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-menu offset-y transition="scroll-y-transition">
                    <template v-slot:activator="{ $attrs, on }">
                      <v-icon
                        v-bind="$attrs"
                        v-on="on"
                        :color="getViewColor(item.is_view)"
                        @click="openConfirmation(item)"
                      >
                        {{
                          item.is_view
                            ? 'mdi-checkbox-marked-circle'
                            : 'mdi-archive'
                        }}</v-icon
                      >
                    </template>
                  </v-menu>
                </template>

                <template v-slot:footer="{}">
                  <paginationComponent
                    @paginationOptions="setPaginationOptions"
                    url="reviews"
                    :filter="filter"
                    :filterAction="true"
                    @getPageNumber="setPagenumber"
                    ref="pagination"
                    @response="receiveService"
                  />
                </template>
                <!-- Action -->
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import paginationComponent from '../shared/components/pagination.vue';
import confirmation from '../../modules/shared/components/confirmation.vue';

export default {
  data: () => ({
    paginationOptions: {},
    reviews: [],
    columns: [
      {
        text: 'Review Data',
        value: 'created_at',
        show: true,
        disabled: false,
        width: '15%',
        align: 'center',
      },
      {
        text: 'Rating',
        value: 'rating_value',
        show: true,
        disabled: false,
        width: '15%',
        align: 'left',
      },
      {
        text: 'Review Type',
        value: 'reviewable_type',
        show: true,
        disabled: false,
        width: '15%',
        align: 'left',
      },
      {
        text: 'Ref No',
        value: 'sale',
        show: true,
        disabled: false,
        width: '15%',
        align: 'left',
      },
      {
        text: 'Customer',
        value: 'sale.customer.name',
        show: true,
        disabled: false,
        width: '15%',
        align: 'left',
      },
      {
        text: 'Comments',
        value: 'comments',
        show: true,
        disabled: false,
        width: '40%',
        align: 'left',
      },
      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        width: '5%',
        align: 'center',
      },
    ],
    filter: {
      search: '',
    },
  }),

  components: {
    paginationComponent,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    receiveService(roledata) {
      this.reviews = roledata;
    },
    salesDetails(event) {
      if (event.reviewable_type == 'sale') {
        this.$router.push(`sales/view/${event.reviewable_id}`);
      }
      if (event.reviewable_type == 'purchase') {
        this.$router.push(`purchase/${event.reviewable_id}`);
      } else {
        event.reviewable_type == null;
      }
    },
    getViewColor(view) {
      switch (view) {
        case true:
          return 'green';
          break;
        case false:
          return 'red';
          break;
        default:
          break;
      }
    },
    openConfirmation(item) {
      let visible = '';
      let allowview = '';
      if (item.is_view == true) {
        visible = 'disable?';
        allowview = false;
      } else {
        visible = 'active?';
        allowview = true;
      }

      let items = {
        id: item.id,
        is_view: allowview,
      };
      confirmation.dialog = true;
      this.$confirm('Do you want to view ' + visible).then((res) => {
        if (res) {
          this.$store
            .dispatch('sms/AllowViewWebsite', items)
            .then((res) => {
              this.$toast.success(res.data);
              this.refreshData();
            })
            .catch((err) => {
              this.$toast.error('Web Review Failed');
            });
        } else {
        }
      });
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>

<style>
.fo-101 {
  font-weight: bold;
}
</style>
